import { gql } from "@apollo/client";

export const GET_AGENT = gql`
  query GetAgent($input: FindAgentInput!) {
    agent(input: $input) {
      id
      type
      category
      engineId
      name
      domain
      description
      status
      buttonNames
      role
      systemPreferences
      defaultPrompt
      temperature
      maxTokens
      onlineSources {
        url
        description
      }
      fileSourceUrls {
        url
        description
      }
      inputSchema
      outputSchema
      tools
      reasoning
      isPublic
      openaiAssistantId
      openaiVectorStoreId
      openaiFiles {
        id
        openaiFileId
        s3Url
        name
        size
        uploadedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_AGENTS = gql`
  query GetAgents($input: FindAgentsInput!) {
    agents(input: $input) {
      total
      agents {
        id
        type
        category
        engineId
        name
        domain
        description
        status
        buttonNames
        role
        systemPreferences
        defaultPrompt
        temperature
        maxTokens
        onlineSources {
          url
          description
        }
        fileSourceUrls {
          url
          description
        }
        inputSchema
        outputSchema
        tools
        isPublic
        openaiAssistantId
        openaiVectorStoreId
        openaiFiles {
          id
          openaiFileId
          s3Url
          name
          size
          uploadedAt
        }
        createdAt
        updatedAt
      }
    }
  }
`;
